"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstructionRowMobile = exports.InstructionRowDesktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../decorators");
var _FormattedComponents = require("../FormattedComponents");
var _Heading = require("../Heading");
var _Text = require("../Text");
var _enums = require("../../enums");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } //helpers
//components
//styled-components
//messages
var InstructionRowBase = (0, _decorators.styleable)(function (_ref) {
  var device = _ref.device,
    id = _ref.id,
    instruction = _ref.instruction,
    params = _ref.params,
    _ref$shouldShowSpinne = _ref.shouldShowSpinnerWhileLoading,
    shouldShowSpinnerWhileLoading = _ref$shouldShowSpinne === void 0 ? false : _ref$shouldShowSpinne,
    store = _ref.store,
    route = _ref.route;
  var imageUrl = instruction.imageUrl,
    stepsNumber = instruction.stepsNumber,
    title = instruction.title,
    type = instruction.type;
  var isLink = store && store.router && route;
  var isMobile = device === 'mobile';
  var InstructionRow = isLink ? _styles.InstructionRowLink : _styles.InstructionRowStatic;
  var Heading = isMobile ? _Heading.HeadingMobile : _Heading.HeadingDesktop;
  var Text = isMobile ? _Text.TextMobile : _Text.TextDesktop;
  var metadata = instruction.metadata ? instruction.metadata : instruction.media && instruction.media.metadata ? instruction.media.metadata : {};
  var isChecklist = type === _enums.INSTRUCTION_TYPE.CHECKLIST;
  var entityMessage = isChecklist ? _messages["default"].x_checks : _messages["default"].x_steps;
  var dataCyHeading = isChecklist ? 'checklist-title' : 'instruction-title';
  var dataCyRow = isChecklist ? 'checklist-card' : 'instruction-card';
  var dataCyEntityNumber = isChecklist ? 'checks-number' : 'steps-number';
  return /*#__PURE__*/_react["default"].createElement(InstructionRow, {
    id: id,
    store: store,
    route: route,
    params: params,
    isLink: isLink,
    device: device,
    dataCy: dataCyRow
  }, /*#__PURE__*/_react["default"].createElement(_styles.StyledCloudinaryPicture, {
    metadata: metadata,
    shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
    shouldShowOverlayShapes: true,
    src: imageUrl
  }), /*#__PURE__*/_react["default"].createElement(_styles.ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.HeadingWrapper, {
    "data-cy": "".concat(dataCyHeading, "-").concat(title.split(' ').join('-'))
  }, isChecklist && /*#__PURE__*/_react["default"].createElement(_styles.ChecklistIcon, null), /*#__PURE__*/_react["default"].createElement(Heading, {
    maxLines: 1,
    size: "xsmall",
    "data-cy": dataCyHeading
  }, title)), /*#__PURE__*/_react["default"].createElement(Text, {
    secondary: true,
    "data-cy": dataCyEntityNumber
  }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, entityMessage, {
    values: {
      stepCount: stepsNumber,
      checkCount: stepsNumber
    }
  })))), isMobile && /*#__PURE__*/_react["default"].createElement(_styles.Chevron, null));
});
var InstructionRowDesktop = exports.InstructionRowDesktop = function InstructionRowDesktop(props) {
  return /*#__PURE__*/_react["default"].createElement(InstructionRowBase, _extends({
    device: "desktop"
  }, props));
};
var InstructionRowMobile = exports.InstructionRowMobile = function InstructionRowMobile(props) {
  return /*#__PURE__*/_react["default"].createElement(InstructionRowBase, _extends({
    device: "mobile"
  }, props));
};
//# sourceMappingURL=index.js.map